import { useContext } from "react";
import { getApolloContext, useApolloClient, useQuery } from "@apollo/client";
import { ArenaPageQuery } from "arena/queries";

/**
 * Техническая страница для WebView приложения сама говорит, что рисуется
 * без шапки и футера. Запрос делает Page, здесь только читаем кэш.
 *
 * При SSR нельзя регистрировать этот запрос: Apollo склеивает запросы
 * с одинаковыми переменными, и Page получил бы наш cache-only вместо
 * своего, страница бы не загрузилась. Поэтому на сервере читаем кэш
 * напрямую: к финальному рендеру Page его уже заполнил
 */
export default function useIsAppOnlyPage(path) {
  const client = useApolloClient();
  const { renderPromises } = useContext(getApolloContext());

  const { data } = useQuery(ArenaPageQuery, {
    variables: { path },
    fetchPolicy: "cache-only",
    ssr: false,
  });

  if (renderPromises) {
    const cached = client.readQuery({
      query: ArenaPageQuery,
      variables: { path },
    });

    return Boolean(cached?.page?.isAppOnly);
  }

  return Boolean(data?.page?.isAppOnly);
}
